import { useEffect } from "react"

import { Switch } from "antd"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { styled } from "styled-components"

import { selectItemsMarkedAsUsefullForAiAssistant } from "../model/selectors/aiAssistantSelectors"
import { fetchAssetAiAssistantFieldsThunk, updateAssetAiAssistantUseForRagFieldThunk } from "../model"
interface UseAssetForAiAssistantSwitchProps {
  itemId: string
}

export const UseAssetForAiAssistantSwitch = ({ itemId }: UseAssetForAiAssistantSwitchProps) => {
  const dispatch = useAppDispatch()
  const itemsMarkedAsUsefullForAiAssistant = useAppSelector(selectItemsMarkedAsUsefullForAiAssistant)

  const isItemMarkedAsUsefullForAiAssistant = itemsMarkedAsUsefullForAiAssistant[itemId]?.useForRagFieldValue

  const handleChange = (checked: boolean) => {
    dispatch(updateAssetAiAssistantUseForRagFieldThunk({ nodeId: itemId, useForRagFieldValue: checked }))
  }

  useEffect(() => {
    dispatch(fetchAssetAiAssistantFieldsThunk({ nodeId: itemId }))
  }, [itemId])

  return (
    <SUseForAiAssistantSwitch
      size="small"
      checked={isItemMarkedAsUsefullForAiAssistant || false}
      onChange={handleChange}
    />
  )
}

const SUseForAiAssistantSwitch = styled(Switch)`
  margin-left: auto;

  &.ant-switch-checked {
    background-color: var(--ant-color-primary-hover);
  }
`